import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DialogService } from 'src/app/core/dialog.service';
import { SubCategory, ProductCategoryService } from 'src/app/core/product-category.service';
import { ProductSubcategoryEditDialogComponent } from '../product-subcategory-edit-dialog/product-subcategory-edit-dialog.component';
import { ProductSubcategoryDeleteDialogComponent } from '../product-subcategory-delete-dialog/product-subcategory-delete-dialog.component';
import { ErrorService, SplittypayError } from 'src/app/core/error.service';
import { PRODUCT_SUBCATEGORY_TABLE_COLUMNS } from 'src/app/shared/constants/operationals';
import { NavigationService } from 'src/app/core/navigation.service';

@Component({
  selector: 'app-product-subcategory-data-table',
  templateUrl: './product-subcategory-data-table.component.html',
  styleUrls: ['./product-subcategory-data-table.component.scss'],
})
export class ProductSubcategoryDataTableComponent {
  @Input() sub_category_collection: SubCategory[] = [];
  @Input() product_category_id: string | null | undefined;
  @Output() refresh: EventEmitter<void> = new EventEmitter<void>();
  @Output() scrolledToEnd: EventEmitter<void> = new EventEmitter<void>();

  displayed_columns: string[] = PRODUCT_SUBCATEGORY_TABLE_COLUMNS;

  constructor(
    private dialog_service: DialogService,
    private error_service: ErrorService,
    private navigation_service: NavigationService,
  ) {}

  onEditClick(subcategory: SubCategory): void {
    this.dialog_service
      .openDialog(ProductSubcategoryEditDialogComponent, {
        product_category_id: this.product_category_id,
        subcategory: subcategory,
      })
      ?.afterClosed()
      .subscribe(dialog_result => {
        if (dialog_result && dialog_result.success) {
          this.refresh.emit();
        }

        if (dialog_result && dialog_result.error) {
          const processed_error: SplittypayError = dialog_result.error;
          this.error_service.processApiError(processed_error.code, processed_error.message);
        }
      });
  }

  onDeleteClick(subcategory: SubCategory): void {
    this.dialog_service
      .openDialog(ProductSubcategoryDeleteDialogComponent, {
        product_category_id: this.product_category_id,
        subcategory: subcategory,
      })
      ?.afterClosed()
      .subscribe(dialog_result => {
        if (dialog_result && dialog_result.success) {
          this.refresh.emit();
        }

        if (dialog_result && dialog_result.error) {
          const processed_error: SplittypayError = dialog_result.error;
          this.error_service.processApiError(processed_error.code, processed_error.message);
        }
      });
  }
}
